import type { ReactElement } from 'react';
import { DialogBody, DialogClose, DialogContent, DialogFooter, DialogHeader, useDialogController } from '@ff-it/ui';
import { Form, FormError, Submit } from '@ff-it/form';
import arrayMutators from 'final-form-arrays';
import { useStore } from 'jotai';
import { usePlanMeta, usePlanMutations, usePlanSettings, useUsedClipIds } from 'modules/campaign/plan/state';
import { planAtom } from 'modules/campaign/plan/state/plan';
import type { PlanSettings } from 'modules/campaign/plan/types';
import { RadioClipsFields } from './RadioClipsFields';
import { dialog as dialogStyle } from './RadioClipsDialog.css';

type RadioClipsValues = Pick<PlanSettings<'RADIO'>, 'radio_clips'>;

export function RadioClipsDialog(): ReactElement {
  const { radio_clips } = usePlanSettings<'RADIO'>();
  const { planning, locked } = usePlanMeta();
  const { updateSettings } = usePlanMutations();
  const usedClipIds = useUsedClipIds();
  const store = useStore();
  const dialog = useDialogController();
  const disabled = !planning || locked;

  return (
    <DialogContent testId="radio-clips" className={dialogStyle}>
      <Form<RadioClipsValues>
        disabled={disabled}
        initialValues={{ radio_clips }}
        mutators={{ ...arrayMutators }}
        display="contents"
        renderErrors={false}
        onSubmit={async (values) => {
          const errors = await updateSettings({ ...store.get(planAtom).settings, ...values });
          if (errors) return errors;
          dialog.setOpen(false);
        }}
      >
        <DialogHeader title="Radio clips" />
        <DialogBody>
          <FormError />
          <RadioClipsFields usedClipIds={usedClipIds} />
        </DialogBody>
        <DialogFooter>
          <DialogClose />
          {!disabled && <Submit ml="auto">Save</Submit>}
        </DialogFooter>
      </Form>
    </DialogContent>
  );
}
